<template>
    <div style="width: 100%;">
        <v-card>
            <v-data-table
                height="67vh"
                dense
                :headers="reportsTableHeaders"
                :items="filteredDesserts"
                item-key="tinNumber"
                no-data-text="KAYDINIZ BULUNMAMAKTADIR.."
                no-results-text="Aradığınız Kriterlerde Sonuç Bulunamadı."
                :items-per-page="paginationObj.pageSize"
            >
                <template
                    v-for="header in reportsTableHeaders"
                    v-slot:[`item.${header.value}`]="{ item }"
                >
                    <div :key="header.value" :class="header.class">
                        <slot  v-if="header.dataType == 'currency'">
                        ""</slot>
                        <slot v-else>{{ item[header.value] }}</slot>
                    </div>
                </template>
                <template slot="header">
                    <th v-for="header in reportsTableHeaders" :key="header.text" >
                        <div>
                            <v-row>
                                <v-text-field
                                    :disabled="header.dataTypeSearch"
                                    style="width: 90px;"
                                    :style="`width:${header.width - 60 + 'px'}; margin-left: 10px;margin-left: 10px;padding-top: 0;margin-top: 0px;`"
                                    v-model="paginationObj.filters[header.value]"
                                    placeholder="Ara"
                                    append-icon="search"
                                ></v-text-field>
                            </v-row>
                        </div>
                    </th>
                </template>
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title style="margin-left:10px" >Karşıt İnceleme Rapor</v-toolbar-title>
                         <v-tooltip class="mb-8" top>
                            <template v-slot:activator="{ on }">
                                <v-btn color="white" style="height: 27px !important;margin-left:8%;" @click="clearFilters()" v-on="on"
                                >Temizle
                                </v-btn>
                            </template>
                            <span>Arama alanlarını temizler</span>
                        </v-tooltip>
                        <v-tooltip class="mb-8" top>
                            <template v-slot:activator="{ on }">
                                <v-btn color="white" style="height: 27px !important;margin-left:5%;" @click="searchUpdate()" v-on="on"
                                    >Ara</v-btn
                                >
                            </template>
                            <span>Girilen arama anahtarlarıyla arama yapar</span>
                        </v-tooltip>
                        <div class="my-2" style="margin-left:7%;">
                            <v-btn color="success" style="height: 3vh !important;margin-top:4%" outlined @click="excelDownload()">
                                İndir
                                <v-icon right>mdi-file-excel</v-icon>
                            </v-btn>
                        </div> 
                    </v-toolbar>
                    <v-divider style="margin-top: 0px;margin-bottom: 0px;"></v-divider>
                </template>
            </v-data-table>
            <div class="text-center" style="padding: 0 0 0 0;">
                <v-row style="padding: 0 3%;">
                    <v-col style="padding-top:0px; padding-bottom:0px">
                        <v-text-field
                            type="number"
                            style="width: 55%;"
                            label="Satır sayısı"
                            :rules="rules.pageSizeRules"
                            @change="searchUpdate()"
                            v-model.number="paginationObj.pageSize"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" style="padding-top:8px; padding-bottom:0px">
                        <v-btn
                            style="min-width: 0;margin-left: 5px"
                            @click="paginationObj.page = 1"
                            v-if="paginationObj.page != 1"
                        >
                            <v-icon>keyboard_arrow_left</v-icon></v-btn>
                        <v-btn
                          v-if="paginationObj.page - 2 > 0"
                          style="min-width: 0;margin-left: 5px"
                          @click="pageStep(-2)"
                          >{{ paginationObj.page - 2 }}</v-btn
                        >
                        <v-btn
                          v-if="paginationObj.page - 1 > 0"
                          style="min-width: 0;margin-left: 5px"
                          @click="pageStep(-1)"
                          >{{ paginationObj.page - 1 }}</v-btn
                        >
                        <v-btn color="primary" style="min-width: 0;margin-left: 5px">{{ paginationObj.page }}</v-btn>
                        <v-btn
                            v-if="paginationObj.page + 1 <= paginationObj.pagesCount"
                            style="min-width: 0;margin-left: 5px"
                            @click="pageStep(1)"
                            >{{ paginationObj.page + 1 }}</v-btn
                        >
                        <v-btn
                            v-if="paginationObj.page + 2 <= paginationObj.pagesCount"
                            style="min-width: 0;margin-left: 5px"
                            @click="pageStep(2)"
                            >{{ paginationObj.page + 2 }}</v-btn
                        >
                        <v-btn
                            style="min-width: 0;margin-left: 5px"
                            @click="paginationObj.page = paginationObj.pagesCount"
                            v-if="paginationObj.page != paginationObj.pagesCount && paginationObj.pagesCount > 1"
                        >   <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                        <div>
                            <center style="color:grey; font-size:13px;margin-top:7px;">
                                sayfada satır sayısı: {{ filteredDesserts.length }}
                            </center>
                        </div>
                    </v-col>
                    <v-col style="padding-top:0px; padding-bottom:0px">
                        <div style="float: right">
                            <p style="font-size: 12px;font-weight:500;margin:3px 0;color:#666A6F">
                              Toplam satır sayısı
                            </p>
                            <p style="float: left; margin-left:1px;">
                              {{ paginationObj.itemCount }}
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <LoaderToUpdate></LoaderToUpdate>
    </div>
</template>

<script>
import LoaderToUpdate from "./loaderToUpdate";
import { sendRequest } from "../request/user";
import Enum from "../tools/Enums.js";
import { axiosUploadTypeArrayBuffer } from '../utils/uploadHelperFormData';
import store from '../store/index'
import { mapState } from "vuex";





export default {
    components: {LoaderToUpdate},
    data() {
        return {
            paginationObj: JSON.parse(JSON.stringify(store.state.defaultPaginationObj)),
            reportsTableItems : [],
            reportsTableHeaders : [
                {
                    text: "Firma İsmi",
                    align: "center",
                    width: "200",
                    value: "companyName",
                    divider: true,
                    excelName: "Firma İsmi",
                },
                {
                    text: "Vergi Kimlik Numarası",
                    value: "tinNumber",
                    width: "150",
                    align: "center",
                    divider: true,
                },
                {
                    text: "Dönem",
                    value: "period",
                    width: "150",
                    align: "center",
                    divider: true,
                },
                {
                    text: "Tutanak Sayısı",
                    value: "totalRecord",
                    width: "150",
                    align: "center",
                    divider: true,
                },
            ],
            rules: {
                required: (value) => !!value || "Gerekli.",
                tinNumber: (value) => value.length >= 10 || "En az 10 karakter gerekli",
                date: (value) => {
                  const pattern = /^([0-2][0-9]|(3)[0-1])(.)(((0)[0-9])|((1)[0-2]))(.)\d{4}$/;
                  return pattern.test(value) || "Geçersiz Tarih";
                },
                maxLength: (value) => {
                  value.length <= 255 || "En fazla 255 karakter girilebilir";
                },
                turkishNumber: (value) => {
                  const pattern = /^\$?([0-9]{1,3}.([0-9]{3}.)*[0-9]{3}|[0-9]+)(,[0-9]{1,8})?$/;
                  return pattern.test(value) || "Geçersiz Sayı Değeri";
                },
                pageSizeRules: [
                  (v) => !!v || "!gerekli alan!",
                  (v) => v < 1001 || "satır sayısı en fazla 1000 olabilir",
                ],
            },
        }
    },
    computed: {
        ...mapState(["showModal", "deleteRowStatus", "bulkUpdateAfter", "loggedUser", "defaultPaginationObj"]),
        filteredDesserts() {
            return this.reportsTableItems;
        },
    },
    watch: {
        "paginationObj.page": function() {
            this.getReportTableItems();
        },
    },
    async created() {
        let loader = {
            loaderToUpdate: true,
            loaderText: "Verileriniz Getiriliyor. Lütfen Bekleyiniz..."
        }
        this.$store.commit("LOADERTOUPDATE", loader);
        await this.getReportTableItems();
        loader = {
            loaderToUpdate: false,
        }
        this.$store.commit("LOADERTOUPDATE", loader);
    },
    methods : {
        // async directVatPeriod() {
        //     let response = await sendRequest( Enum.requestType.POST,"adminReportsItems","",{ choice: "getData" } );
        //     if (response.status == 200) {
        //         this.reportsTableItems = response.data.data.value
        //     }else{
        //         this.$store.state.snackbarErrorObj = {
        //             snackbar: true,
        //             color: "error",
        //             text: "Sorun Oluştu",
        //             timeout: 2500
        //         };
        //     }
        // },
        async getReportTableItems() {
            this.$store.commit("LOADER", true);
            let pgObj = JSON.parse(JSON.stringify(this.paginationObj))
            //pgObj.filters = await ObjectMethods.searchFilterArrangement(this.vatDirectReportHeaders, pgObj.filters)
            await sendRequest(Enum.requestType.POST,"adminReportsItems","",{choice :"getData", paginationObj:pgObj,type : undefined })
                .then(async (response) => {
                  let flexCount = response.data.data.value.length == 0 ? 0 : response.data.data.value[0].fullCount
                  this.paginationObj.pagesCount = Math.ceil(Number(flexCount) / Number(this.paginationObj.pageSize));
                  this.paginationObj.itemCount = flexCount;
                  this.reportsTableItems = response.data.data.value;
                });
            this.$store.commit("LOADER", false);
        },
        async excelDownload() {
            let loader = {
                loaderToUpdate: true,
                loaderText: "Verileriniz Getiriliyor. Lütfen Bekleyiniz..."
            }
            this.$store.commit("LOADERTOUPDATE", loader);
            let response = await sendRequest( Enum.requestType.POST,"adminReportsItems","",{ choice: "adminRecordReport" } );
            if (response.status == 200) {
                await axiosUploadTypeArrayBuffer("adminRecordReport", "Karşıt İnceleme Rapor")
            }else{
                this.$store.state.snackbarErrorObj = {
                    snackbar: true,
                    color: "error",
                    text: "Sorun Oluştu",
                    timeout: 2500
                };
            }
        },
        pageStep(step) {
            this.paginationObj.page += step;
        },
        searchUpdate() {
            if (this.paginationObj.pageSize <= 1000 && this.paginationObj.pageSize !== "") {
                this.paginationObj.pagesCount = 0;
                this.paginationObj.itemCount = 0;
                this.paginationObj.page = 1;
                this.getReportTableItems();
            }
        },
        clearFilters() {
            this.paginationObj.filters = {};
            this.paginationObj.pageSize = this.$store.state.defaultPaginationObj.pageSize;
            this.searchUpdate();
        }
    }
};
</script>

<style scoped>
::v-deep .threedot {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 200px;
}
::v-deep .threedot:hover {
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}
</style>
